import { initializeApp } from 'https://www.gstatic.com/firebasejs/9.17.1/firebase-app.js';
import { getDatabase, onValue, ref } from "https://www.gstatic.com/firebasejs/9.17.1/firebase-database.js";

const ANALYYZE = 'analyze';

const firebaseConfig = {
  apiKey: "AIzaSyC0-YLBGK3sdXsaeYvDMDTWXsCz9qLrcWU",
  authDomain: "sofie-pavitt.firebaseapp.com",
  projectId: "sofie-pavitt",
  storageBucket: "sofie-pavitt.appspot.com",
  messagingSenderId: "445323208192",
  appId: "1:445323208192:web:2d4e0132767de37da19ae5",
  databaseURL: "https://sofie-pavitt-default-rtdb.firebaseio.com",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Realtime Database and get a reference to the service
const db = getDatabase(app);
const ingredientsRef = ref(db, 'ingredients');

class IngredientChecker extends HTMLElement {
  constructor() {
    super();

    this.checkerButton = this.querySelector('.js-checker-button');
    this.textareaWrapper = this.querySelector('.js-textarea-wrapper');
    this.goodNewsEl = this.parentElement.querySelector('.js-goodnews');
    this.troubleEl = this.parentElement.querySelector('.js-trouble');
    this.troubledIngredientsList = [];
    this.parsedIngredients = [];
    this.identifiedTroubledIngredients = [];

    this.addEventListener('submit', this.handleCheckersubmit.bind(this));
    onValue(ingredientsRef, (snapshot) => {
      const data = snapshot.val();

      this.troubledIngredientsList = Object.values(data);
    });
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.handleCheckersubmit);
    this.textareaWrapper.removeEventListener('change', this.hideLabel);
  }

  analyzeIngredients() {
    const textarea = this.textareaWrapper.querySelector('textarea');

    if (textarea.value == '') return console.log('write a need ingredients error boundary');

    this.parsedIngredients = textarea.value.split(/[.,\()]/g).reduce((acc, curr) => {
      if (curr === '') return acc;

      return [
        ...acc,
        this.getSanitizedIngredient(curr)
      ];
    }, []);

    this.crossReferenceIngredients();
  }

  clearTextarea() {
    this.textareaWrapper.querySelector('textarea').value = '';
  }

  clearTroubledElements() {
    this.troubleEl.innerHTML = '';
    this.troubleEl.classList.remove('expanded');
  }

  crossReferenceIngredients() {
    this.identifiedTroubledIngredients = this.troubledIngredientsList.reduce((acc, curr) => {
      if (this.parsedIngredients.includes(this.getSanitizedIngredient(curr.name))) return [...acc, curr];

      return acc;
    }, []);
  }

  getSanitizedIngredient(ingredient) {
    return ingredient.trim().toLowerCase().replace(/[\.,\/#!$%\^&\*;:{}=\-_`~\(\)\n]/g, "").replaceAll(' ', '');
  }

  getTroubledElementsHTML() {
    return this.identifiedTroubledIngredients.map(({ name, notes }) => {
      const notesEl = notes?.length > 0 ? `<br><span class="body--small">Sofie's notes: ${notes}</span>` : '';
      return `<li>
        <span class="text-darkgrey">${name}</span> is known to clog pores.${notesEl}
      </li>`
    }).join(' ');
  }

  handleCheckersubmit(e) {
    e.preventDefault();

    const { currentAction } = this.checkerButton.dataset;

    switch (currentAction) {
      case 'trigger':
        this.setAnalyze();
        this.showTextArea();
        break;

      case ANALYYZE:
        this.analyzeIngredients();
        this.showTroubledIngredients();
        this.checkerButton.dataset.currentAction = 'reset';
        this.checkerButton.innerHTML = 'analyze another product';
        break;

      case 'reset':
        this.goodNewsEl.classList.remove('expanded');
        this.setAnalyze();
        this.clearTextarea();
        this.clearTroubledElements();
        this.showTextArea();
        break;

      default:
        break;
    }
  }

  hideLabel() {
    const textarea = this.textareaWrapper.querySelector('textarea');

    if (textarea.value != '') textarea.nextElementSibling.classList.add('hidden');
    else textarea.nextElementSibling.classList.remove('hidden');
  }

  hideTextArea() {
    this.clearTextarea();
    this.textareaWrapper.classList.remove('expanded');
    this.textareaWrapper.removeEventListener('change', this.hideLabel);
  }

  setAnalyze() {
    this.checkerButton.dataset.currentAction = ANALYYZE;
    this.checkerButton.innerHTML = ANALYYZE;
  }

  populateTroubleElements() {
    this.troubleEl.insertAdjacentHTML('afterbegin', this.getTroubledElementsHTML());
    this.troubleEl.classList.add('expanded');

    if (window.matchMedia('(max-width: 749px').matches) this.troubleEl.scrollIntoView();
  }

  showTextArea() {
    this.textareaWrapper.classList.add('expanded');
    this.textareaWrapper.addEventListener('change', this.hideLabel.bind(this));

    if (window.matchMedia('(max-width: 749px').matches) this.textareaWrapper.scrollIntoView({ block: 'center' });
  }

  showTroubledIngredients() {
    this.hideTextArea();

    if (this.identifiedTroubledIngredients.length == 0) {
      this.goodNewsEl.classList.add('expanded');

      if (window.matchMedia('(max-width: 749px').matches) this.goodNewsEl.scrollIntoView();
    } else {
      this.populateTroubleElements();
    }
  }
}

customElements.define('ingredient-checker', IngredientChecker);
